<span
    [class]="busy ? '' : 'link'"
    (click)="reprocess()"
    *ngIf="!requestSent"
>{{busy ? 'Busy ...' : 'Reprocess'}}</span>
